<template>
<div class="container-fluid bg-default-color">
	<service-toolbar
		:show-title-widget="true"
		:show-details-in-title="true" 
		title-widget-width="md">		
	</service-toolbar>

	<div class="widget-container" style="max-width: 1000px;">

		<widget v-if="!('work_to_do_disabled' in $store.service && $store.service.work_to_do_disabled == 1)" title="Work Requested Acknowledgement" class="form">
			<button class="btn btn-light" type="button" v-on:click="openWOSummary(true,true)">
				<i class="fa fa-list-alt"></i>
				View Work Requested Summary
			</button>
		</widget>

		<widget title="Description of Work To Do" class="form">
			<div v-html="stripInlineEventHandlers($store.service.description)"></div>

			<div v-if="'CustomerAsset' in $store.service && $store.service.CustomerAsset && $store.service.CustomerAsset.length">
				<hr>
				<strong>Customer assets involved in this service</strong>
				<ul class="mt-2">
					<li v-for="asset in mutatedCustomerAssets">
						<a :href="asset.link" v-on:click.prevent="navigateToAsset(asset.link)">{{asset.description}}</a>
					</li>
				</ul>
			</div>
		</widget>

		<div class="action-buttons-container d-flex justify-content-between flex-wrap mb-2">
			<div>
				<button v-if="!quoteDetailsVisible && quoteRecord" class="btn btn-light mr-1" v-on:click="showQuoteDetails">
					<i class="fa fa-file-invoice-dollar"></i>
					View Quote Materials & Equipment
				</button>
			</div>
			<div>
				<span v-if="readonly" class="text-muted">This service has a status that makes it readonly</span>
				<button type="button" class="btn btn-success" :disabled="readonly" v-on:click="addNewEntry">
					<i class="fa fa-plus"></i>
					Work Completed
				</button>
			</div>

		</div>
		<div v-if="quoteDetailsVisible">

			<widget title="Quote Details" header-button="fa-times" v-on:headerButtonClick="quoteDetailsVisible = false">

				<h4>Materials Quoted</h4>
				<table-list record-name="Material"
					:fields="partsFields"
					:records="quotedItems.materials"
					:hide-record-count="true"
					:sortable="true">
				</table-list>

				<h4>Equipment Quoted</h4>

				<table-list record-name="Equipment Item"
					:fields="equipmentUsedFields"
					:records="quotedItems.equipment"
					:hide-record-count="true"
					:sortable="true">
				</table-list>

			</widget>
		</div>

		<work-completed-entry v-for="(entry,index) in worksheets" 
			:key="'id' in entry ? entry.id : 'new'+index"
			:entry="entry"
			:readonly="readonly"
			:parent-id="$store.service.id"
			parent-id-key="service_id"
			:parts-fields="partsFields"
			:equipment-used-fields="equipmentUsedFields"
			:equipment-list="$store.equipments"
			:task-options="taskOptions"
			:trigger-edit-mode="!('id' in entry)"
			:suggested-materials="suggestedMaterials"
			
			worksheet-api-resource="ServiceWorksheet"
			v-on:addingMaterialsUsed="addingMaterialsUsed"
			v-on:entryDeleted="fetchWorksheets"
			v-on:removeEntry="removeEntry(index)"
			v-on:entrySaved="fetchWorksheets"
			v-on:addChecklists="addAssetChecklists"
			v-on:addForms="addAssetForms">
		</work-completed-entry>

		<a id="endOfEntries"></a>

		<div v-if="worksheets.length > 10" class="float-right mb-2">
			<span v-if="readonly" class="text-muted">This service has a status that makes it readonly</span>
			<button type="button" class="btn btn-success ml-2" :disabled="readonly" v-on:click="addNewEntry">
				<i class="fa fa-plus"></i>
				Add another Work Completed Entry
			</button>
		</div>
		<div style="clear: both;"></div>

		<widget title="Required Checklists" class="form">

			<div v-if="!readonly" slot="header" class="d-flex justify-content-end mt-2 mr-2">
				<button type="button" class="btn btn-primary" v-on:click="openAddChecklistModal">
					<i class="fa fa-plus"></i>
					Add Checklist
				</button>
			</div>

			<checklist-fillable-list
				v-if="'JobChecklist' in $store.service && $store.service.JobChecklist"
				:checklists="$store.service.JobChecklist"
				:readonly="readonly">
			</checklist-fillable-list>

		</widget>

		<widget title="Required Forms" class="form">

			<div v-if="!readonly" slot="header" class="d-flex justify-content-end mt-2 mr-2">
				<button type="button" class="btn btn-primary" v-on:click="openAddChildTemplateModal">
					<i class="fa fa-plus"></i>
					Add Form
				</button>
			</div>

			<table-list
				:fields="[
					{label:'Description',    key:'description'},
					{label:'Status',         key:'status'},
					{label:'Completed At',   key:'completedAt'},
					{label:'Participants',   key:'participantsList'},

				]"
				:other-buttons="[
					{
						text: 'Do Form',
						icon: 'fa-clipboard-check',
						click: 'doCompanyForm',
						class: 'btn-light',
						condition: ['isComplete', false]
					}
				]"
				:records="mutatedFormChildTemplates"
				:hide-record-count="true"
				:sortable="false"
				:has-delete="true"
				v-on:doCompanyForm="doCompanyForm"
				v-on:delete="removeFormChildTemplate">
			</table-list>

		</widget>


		<widget class="form">

			<template v-if="classifiedTimeLogs.length > 0">
				<h4>Labour Summary</h4>
				<table-list record-name="Classification"
					:fields="[
						{label: 'Classification',key: 'title'},
						{label: 'Type',key: 'timeType', align:'left'},
						{label: 'Total Time Claimed',key: 'totalTimeClaimed', align:'right'}
					]"
					:records="classifiedTimeLogs">
				</table-list>
			</template>

			<div v-if="!serviceIsFieldEditable"
				class="alert alert-warning" 
				style="margin-left: -15px;margin-right: -15px;margin-top: -15px;">

				This service is in {{$store.service.status}} status, is read-only now, and cannot be reverted back to a previous status from here.
				<template v-if="hasModulePermWrite('Services') || getUserRoleType() == 'Admin'">
					The status can only be reverted from the <router-link to="details">Details</router-link> tab.
				</template>
				<template v-else>To revert the status you need write permissions</template>
			</div>

			<form-group label="Total Hours for Sign-off"
				col-class="col-md-2 col-sm-3">

				<div class="row">
					<div class="col-auto">
						<field label="Reg"
							col-class="col-auto"
							:params="{type:'number',step:0.25}"
							v-model="$store.service.summary_total_hours"
							v-on:change="saveSummaryHours">
						</field>
					</div>
					<div class="col-auto">
						<field label="OT"
							col-class="col-auto"
							:params="{type:'number',step:0.25}"
							v-model="$store.service.summary_total_hours_ot"
							v-on:change="saveSummaryHours">
						</field>
					</div>
				</div>

				<p class="mt-2">
					Total Calculated Time: <strong>{{ totalCalculatedHours }}</strong> ({{ logsConfirmed ? 'confirmed' : 'unconfirmed' }})<br>
					<span class='text-muted'>(Calculated using claimed hours for closed time logs, and total elapsed time for open time logs)</span>
				</p>

			</form-group>

			<form-group label="WO Summary" col-class="col-md-2 col-sm-3">
				<button class="btn btn-light" type="button" v-on:click="openWOSummary(!('work_orders_disabled' in $store.service && $store.service.work_orders_disabled == 1),false)">
					<i class="fa fa-list-alt"></i>
					View WO Summary
					<span v-if="!('work_orders_disabled' in $store.service && $store.service.work_orders_disabled == 1)"> & Capture Signature</span>
				</button>
			</form-group>

			<wo-summary
				:visible="WOSummaryVisible"
				:service="$store.service"
				:work-completed-entries="'ServiceWorksheet' in $store.service ? $store.service.ServiceWorksheet : null"
				:hide-sig="!WOSummaryShowSig"
				:work-to-do-summary="WoSummaryWorkToDoSummary"
				v-on:closeModal="WOSummaryVisible = false">		
			</wo-summary>

			<field 
				label="Status" 
				col-class="col-md-2 col-sm-3" 
				:params="{type:!statusReadonly ? 'select' : 'text',options:serviceStatusOptions('field')}" 
				v-model="$store.service.status" 
				:readonly="statusReadonly" 
				:invalid="$store.errorList.status"
				v-on:change="statusChanged">
			</field>

			<field v-if="$store.service.status == 'Completed'"
				label="Completed Date" 
				col-class="col-md-2 col-sm-3" 
				:params="{type:'date'}" 
				v-model="$store.service.completed" 
				:readonly="statusReadonly"
				:invalid="$store.errorList.completed">
			</field>

		</widget>

		<div class="float-right mb-2">
			<button type="button" class="btn btn-success" v-on:click="saveWorksheet(true)">
				<i class="fa fa-clock"></i>
				Done & Clock Out
			</button>
		</div>
		<div style="clear: both;"></div>

	</div>

	<modal-dialog
		:modal-visible="statusChangePromptModal.visible"
		title="Update Status?"
		confirm-button-text="Set to Completed"
		:cancel-button-text="'Keep status as '+$store.service.status"
		v-on:confirm="confirmSetCompleted"
		v-on:closeModal="$router.push('/punch-clock')">

		Would you like to change the status of this job to <strong>Completed</strong>?

	</modal-dialog>


	<modal-dialog
		:modal-visible="addChecklistModal.visible"
		title="Add Checklist"
		confirm-button-text="Add"
		:submit-visible="addChecklistModal.selectedChecklistId"
		v-on:confirm="addNewChecklist"
		v-on:closeModal="addChecklistModal.visible = false">

		<field
			label="Checklist"
			col-class="col-3"
			:params="{type:'select',options:checklistOptions}"
			:readonly="readonly"
			v-model="addChecklistModal.selectedChecklistId"
			v-on:change="">
		</field>

	</modal-dialog>


	<modal-dialog
		:modal-visible="addFormChildTemplateModal.visible"
		title="Add Required Form"
		confirm-button-text="Add"
		:submit-visible="addFormChildTemplateModal.selectedFormChildTemplateId"
		v-on:confirm="addNewFormChildTemplate"
		v-on:closeModal="addFormChildTemplateModal.visible = false">

		<field
			label="Form"
			col-class="col-2"
			:params="{type:'select',options:formChildTemplateOptions}"
			:readonly="readonly"
			v-model="addFormChildTemplateModal.selectedFormChildTemplateId"
			v-on:change="">
		</field>

	</modal-dialog>

</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import VueForm from "@/components/VueForm"
import Widget from "@/components/Widget"
import WorkCompletedEntry from "@/components/super_components/WorkCompletedEntry"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import ChecklistFillableList from "@/components/super_components/ChecklistFillableList"

import WoSummary from "@/components/super_components/WoSummary"

import ServiceToolbar from "./ServiceToolbar"
import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "ServiceWorkSheet",
	components: {
		ServiceToolbar,
		VueForm,
		Field,
		FormGroup,
		WoSummary,
		Widget,
		WorkCompletedEntry,
		TableList,
		ModalDialog,
		ChecklistFillableList
	},
	mixins: [ServiceMixins],
	data() {
		return {
			worksheets: [],
			formWorking: false,
			mapVisible: false,
			serviceStatusChecked: false,
			contractScheduleOfValues: [],
			tasksDone: [],
			equipmentUsed: [],
			materialModalVisible: false,
			checklists: [],
			formChildTemplates: [],
			timeLogs: [],
			workCompletedEntries: [],
			statusChangePromptModal: {
				visible: false
			},
			suggestedMaterials: [],
			WOSummaryVisible: false,
			WOSummaryShowSig: true,
			WoSummaryWorkToDoSummary: false,
			equipmentUsedFields: [
				{label:'Equipment Type',key:'equipmentType'},
				{label:'Equipment Description',key:'description'},
				{label:'Qty',key:'eqQty',align:'right'}
			],
			quoteDetailsVisible: false,
			quote: false,

			fetchingServiceData: false,

			addChecklistModal: {
				visible: false,
				selectedChecklistId: null
			},

			addFormChildTemplateModal: {
				visible: false,
				selectedFormChildTemplateId: null
			},
			fieldsPopulatingInitially: true
		}
	},
	watch: {
		'$store.service'() {
			this.setWorksheet()
			this.fetchServiceData()

			if (this.timeLogs.length == 0)
				this.fetchTimeLogs()
			if (this.checklists.length == 0)
				this.fetchChecklists()
			if (this.formChildTemplates.length == 0)
				this.fetchFormChildTemplates()
		},
		'$store.service.completed'() {
			this.statusChanged()
		}
	},
	computed: {
		mutatedCustomerAssets() {
			if (!('CustomerAsset' in this.$store.service && this.$store.service.CustomerAsset))
				return []

			return this.$store.service.CustomerAsset.map(asset => {
				asset.link = ""
				if ('slug' in asset && asset.slug)
					asset.link = "/contact/asset/" + asset.slug + "/log"

				return asset
			})
		},
		formChildTemplateOptions() {
			return this.optionify(this.formChildTemplates, 'description')
		},
		classifiedTimeLogs() {
			let classifications = []

			this.timeLogs.forEach(log => {
				let classification = false

				try {
					classification = JSON.parse(log.classification_json)
				}
				catch (e) {}

				if (classification && "id" in classification) {
					if (log.regular_hours > 0) {
						let foundIndex = classifications.findIndex(cl => cl.id == classification.id && cl.timeType == 'Reg')

						let time = +log.regular_hours

						if (foundIndex >= 0) {
							classifications[foundIndex].totalTimeClaimedRaw += time
							classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)
						}
						else {
							classifications.push({
								id: classification.id,
								title: classification.title,
								timeType: "Reg",
								totalTimeClaimedRaw: time,
								totalTimeClaimed: time.toFixed(2)
							})
						}
					}

					let otKeys = ["overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]

					otKeys.forEach(key => {
						if (log[key] > 0) {

							let time = 0
							if (key in log && log[key])
								time = +log[key]

							let foundIndex = classifications.findIndex(cl => cl.id == classification.id && cl.timeType == 'OT')

							if (foundIndex >= 0) {
								classifications[foundIndex].totalTimeClaimedRaw += +log[key]
								classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)	
							}
							else {
								classifications.push({
									id: classification.id,
									title: classification.title,
									timeType: "OT",
									totalTimeClaimedRaw: time,
									totalTimeClaimed: time.toFixed(2)
								})
							}
						}
					})
				}
				else {
					if (log.regular_hours > 0) {
						let foundIndex = classifications.findIndex(cl => cl.id == 0 && cl.timeType == 'Reg')

						let time = 0
						if (key in log && log[key])
							time = +log[key]

						if (foundIndex >= 0) {
							classifications[foundIndex].totalTimeClaimedRaw += time
							classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)
						}
						else {
							classifications.push({
								id: 0,
								title: "Unclassified",
								timeType: "Reg",
								totalTimeClaimedRaw: time,
								totalTimeClaimed: time.toFixed(2)
							})
						}
					}

					let otKeys = ["overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]

					otKeys.forEach(key => {
						if (log[key] > 0) {

							let time = +log[key]

							let foundIndex = classifications.findIndex(cl => cl.id == 0 && cl.timeType == 'OT')

							if (foundIndex >= 0) {
								classifications[foundIndex].totalTimeClaimedRaw += +log[key]
								classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)	
							}
							else {
								classifications.push({
									id: 0,
									title: "Unclassified",
									timeType: "OT",
									totalTimeClaimedRaw: time,
									totalTimeClaimed: time.toFixed(2)
								})
							}
						}
					})
				}
				
			})

			return classifications
		},
		mutatedFormChildTemplates() {
			if (!(this.$store.service && 'FormChildTemplate' in this.$store.service && this.$store.service.FormChildTemplate))
				return []

			return this.$store.service.FormChildTemplate.map(childTemplate => {

				childTemplate.isComplete = false
				childTemplate.completedAt = ""
				childTemplate.participantsList = ""

				if ('CompanyForm' in this.$store.service && this.$store.service.CompanyForm) {

					const form = this.$store.service.CompanyForm.find(form => form.child_template_id == childTemplate.id)

					if (form) {

						childTemplate.isComplete = true
						childTemplate.completedAt = this.formatDateTimeToLocal(form.created_at)

						if ('CompanyFormAcknowledgement' in form && form.CompanyFormAcknowledgement) {
							childTemplate.participantsList = form.CompanyFormAcknowledgement.map(part => part.name).join(", ")

							if (childTemplate.participantsList.length > 40)
								childTemplate.participantsList = childTemplate.participantsList.substr(0,40)+"..."

							// Overwrite completed_at if only one form participant
							if (form.CompanyFormAcknowledgement.length) {
								if ('completed_at' in form.CompanyFormAcknowledgement[0] && form.CompanyFormAcknowledgement[0].completed_at)
									form.completedAt = this.formatDateTimeToLocal(form.CompanyFormAcknowledgement[0].completed_at)
							}
						}
					}
				}

				if (childTemplate.isComplete)
					childTemplate.status = "<span class='text-success'>Complete</span>"
				else
					childTemplate.status = "<span class='text-danger'>Incomplete</span>"

				return childTemplate
			})
		},
		checklistOptions() {
			return this.optionify(this.checklists, 'name')
		},
		hasMultipleWorksheets() {
			if (this.$store.service.ServiceWorksheet && this.$store.service.ServiceWorksheet.length > 0)
				return true
			else
				return false
		},
		serviceIsFieldEditable() {
			let status = this.$store.serviceStatuses.find(status => this.$store.service.status == status.label)

			if (status) {
				if (status.type == 'office')
					return false
			}

			return true
		},
		readonly() {
			if (this.hasModulePermWrite("Services") && this.$store.service.status == "Completed")
				return false

			let vm = this
			//if status is of type office

			if (this.$store.service.status == "Completed")
				return true

			let readonly = false
			this.$store.serviceStatuses.forEach(status => {
				if (status.label == vm.$store.service.status && status.type == 'office')
					readonly = true
			})

			return readonly
		},
		statusReadonly() {
			if (this.$store.service.archived == 0 && this.serviceIsFieldEditable) {
				return false
			}
			else
				return true
		},
		taskOptions() {
			if (this.isset(this,"$store.service.ServiceContract.ServiceContractTask"))
				return this.optionify(this.$store.service.ServiceContract.ServiceContractTask.map(task => {
					task.displayField = task.item_number + ": "+task.description

					return task
				}),"displayField")
			
			return []
		},
		totalCalculatedHours() {
			let vm = this
			if (this.timeLogs && this.timeLogs.length > 0) {
				let totalClaimedRegHrs = this.timeLogs.reduce((total,log) => total
						+parseFloat(log.regular_hours),
					0)

				let totalClaimedOtHrs = this.timeLogs.reduce((total,log) => total
						+parseFloat(log.overtime_hours_15x)
						+parseFloat(log.overtime_hours_2x)
						+parseFloat(log.overtime_hours_25x),
					0)

				let totalElapsedHrs = this.timeLogs.reduce((total,log) => {
					if (log.time_out == "0000-00-00 00:00:00") {
						//this log is still open
						let timeIn = vm.moment.utc(log.time_in)
						let hrsDiff = timeIn.diff(vm.moment.utc(),'hours')

						return total+hrsDiff
					}
					else
						return total
				},0)

				let totalRegHrs = totalClaimedRegHrs+totalElapsedHrs

				let combined = totalRegHrs.toFixed(2)

				if (totalClaimedOtHrs > 0) {
					let totalOtHours = totalClaimedOtHrs.toFixed(2)
					combined += " REG hrs, " + totalOtHours + " OT hrs"
				}
				else
					combined += " hrs"

				return combined
			}
			else 
				return "0.00 hrs"
		},
		logsConfirmed() {
			let confirmed = true
			this.timeLogs.forEach(log => {
				if (log.reviewed_by == 0)
					confirmed = false
			})

			return confirmed
		},
		quotedItems() {
			let vm = this

			let quotedItems = {
				materials: [],
				equipment: []
			}

			if (this.quote) {
				let materials = this.quote.ServiceInvoiceObject.filter(item => item.type == 'Material').map(mat => {
					
					let matFields = {}
					try {
						matFields = JSON.parse(mat.field_values_json)
					}
					catch (e) {}

					matFields.qty = parseFloat(matFields.qty).toFixed(1)

					return matFields
				})
				let equipmentItems = this.quote.ServiceInvoiceObject.filter(item => item.type == 'Equipment').map(mat => {
					
					let equipmentFields = {}
					try {
						equipmentFields = JSON.parse(mat.field_values_json)
					}
					catch (e) {}

					equipmentFields.equipmentType = equipmentFields.typeName
					equipmentFields.description = equipmentFields.name

					let eqQty = parseFloat(equipmentFields.qty).toFixed(2) + " " + equipmentFields.unit + "s"
					equipmentFields.eqQty = eqQty

					return equipmentFields
				})

				quotedItems.materials = materials
				quotedItems.equipment = equipmentItems
			}

			return quotedItems
		},
	},
	methods: {
		openWOSummary(show_sig,workToDoSummary) {
			this.WOSummaryVisible = true
			this.WOSummaryShowSig = show_sig
			this.WoSummaryWorkToDoSummary = workToDoSummary
		},
		addAssetForms(asset) {
			const newIds = asset.FormChildTemplate.map(fct => fct.id)
			this.saveFormChildTemplates(newIds)
		},
		addAssetChecklists(asset) {
			const newIds = asset.Checklist.map(checklist => checklist.id)
			this.saveChecklists(newIds, asset.id)
		},
		removeFormChildTemplate(childTemplate, index) {
			const vm = this

			let newChildTemplates = this.cloneObj(this.$store.service.FormChildTemplate)
			newChildTemplates.splice(index, 1)

			const payload = {
				id: this.$store.service.id,
				FormChildTemplate: newChildTemplates.map(fct => fct.id)
			}

			this.postData('Service/save', payload).then(response => {
				if (response.success)
					vm.$store.service.FormChildTemplate = newChildTemplates
			})
		},
		saveFormChildTemplates(newChildTemplateIds) {
			const vm = this

			let allChildTemplateIds = [...newChildTemplateIds]    // copy

			if ('FormChildTemplate' in this.$store.service && this.$store.service.FormChildTemplate)
				allChildTemplateIds = [
					...allChildTemplateIds,
					...this.$store.service.FormChildTemplate.map(fct => fct.id)
				]

			const payload = {
				id: this.$store.service.id,
				FormChildTemplate: allChildTemplateIds
			}

			this.postData('Service/save', payload, true).then(response => {
				if (response.success) {
					vm.alertSuccess('Form added')
					vm.addFormChildTemplateModal.visible = false

					newChildTemplateIds.forEach(newRecordId => {
						const fullTemplate = vm.formChildTemplates.find(fct => fct.id == newRecordId)
						vm.$store.service.FormChildTemplate.push(fullTemplate)
					})
				}
			})
		},
		addingMaterialsUsed() {
			if (this.suggestedMaterials.length == 0)
				this.fetchSuggestedMaterials()
		},
		addNewFormChildTemplate() {
			const newIds = [this.addFormChildTemplateModal.selectedFormChildTemplateId]
			this.saveFormChildTemplates(newIds)
		},
		addNewChecklist() {
			const newIds = [this.addChecklistModal.selectedChecklistId]
			this.saveChecklists(newIds)
		},
		openAddChildTemplateModal() {
			this.addFormChildTemplateModal.selectedFormChildTemplateId = null
			this.addFormChildTemplateModal.visible = true
		},
		doCompanyForm(childTemplate) {
			this.$bus.$emit("doCompanyForm",{
				service_id: this.$store.service.id,
				doChildTemplateIdList: [childTemplate.id]
			})
		},
		navigateToAsset(link) {
			console.log(link)
			this.$store.lastRoute = this.$route.path
			this.$router.push(link)
		},
		saveChecklists(newChecklistIds, customer_asset_id=0) {
			const vm = this

			let records = newChecklistIds.map(id => {
				const fullChecklist = this.checklists.find(checklist => checklist.id == id)//this.addChecklistModal.selectedChecklistId)
				return {
					customer_asset_id,
					service_id: this.$store.service.id,
					checklist_id: fullChecklist.id,
					name: fullChecklist.name,
					items_json: fullChecklist.items_json
				}
			})


			if (records.length == 1) {

				let payload = records[0]

				this.postData('JobChecklist/save', payload).then(response => {
					if (response.success) {
						vm.alertSuccess('Checklist added')
						vm.addChecklistModal.visible = false

						vm.getJSON('JobChecklist/find/' + response.data.record_id, false, true).then(fetchResponse => {
							if (fetchResponse.success) {
								vm.pushToServiceChecklist(fetchResponse.data)
							}
						})
					}
				})

			} else {

				const payload = { records: JSON.stringify(records) }

				this.postData('JobChecklist/save-batch', payload).then(response => {
					if (response.success) {
						vm.alertSuccess(records.length + ' checklists added')

						const params = {
							filters: [['id', response.data.records_saved_list]],
							include: [
								{
									model: "CustomerAsset",
									fields: ["id", "slug", "description"]
								},
								"Category"
							]
						}

						vm.getJSON('JobChecklist/get', params, true).then(fetchResponse => {
							if (fetchResponse.success)
								vm.pushToServiceChecklist(...fetchResponse.data)
						})
					}
				})
			}
		},
		pushToServiceChecklist(item) {
			if (!("JobChecklist" in this.$store.service))
				this.$store.service.JobChecklist = []
				
			this.$store.service.JobChecklist.push(item)

			this.$forceUpdate()
		},
		openAddChecklistModal() {
			this.addChecklistModal.selectedChecklistId = null
			this.addChecklistModal.visible = true
		},
		showQuoteDetails() {
			let vm = this

			if (this.quote)
				this.quoteDetailsVisible = true
			else {

				//find quote
				let quote = this.$store.service.ServiceInvoice.find(inv => inv.is_quote == 1)

				if (quote) {

					let params = {
						include: ["ServiceInvoiceObject"]
					}
					vm.spinner(true)
					this.getJSON("ServiceInvoice/find/"+quote.slug,params).then(response => {
						vm.spinner(false)
						vm.quoteDetailsVisible = true
						if (response.success) 
							vm.quote = response.data
					})

				}
			}
		},
		scrollToAnchorWithOffset(offset = 100) {
			this.$nextTick(() => {
				const el = document.getElementById('endOfEntries');
				if (el) {
					const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
					window.scrollTo({ top: y, behavior: 'smooth' });
				}
			});
		},
		addNewEntry() {
			this.worksheets.push({
				work_completed_description: "",
				service_id: this.$store.service.id
			})

			this.scrollToAnchorWithOffset(280)
		},
		removeEntry(index) {
			if (index == 0) {
				this.alertFail("Can't delete an entry if its the only one.")
			}
			else
				this.worksheets.splice(index,1)
		},
		confirmSetCompleted() {
			this.$store.service.status = 'Completed'
			if (!this.$store.service.completed)
				this.$store.service.completed = this.moment().format("YYYY-MM-DD")
			this.saveWorksheet(true)
		},
		statusChanged() {
			let vm = this

			const oldStatus = vm.$store.service.status

			if (!this.fieldsPopulatingInitially) {

				this.$nextTick(() => {
					const incompleteForms = vm.mutatedFormChildTemplates.filter(form => !form.isComplete)

					if (vm.$store.service.status == "Completed") {
						if (incompleteForms.length) {
							vm.alertFail('Must complete all required forms before marking this service as "Complete"')
							vm.$store.service.status = oldStatus
							return

						} else if (!vm.$store.service.completed)
							vm.$store.service.completed = vm.moment().format("YYYY-MM-DD")
					}

					vm.saveWorksheet()
				})
			}
		},
		saveSummaryHours() {
			let vm = this

			this.$nextTick(() => {
				let payload = {
					id: vm.$store.service.id,
					summary_total_hours: vm.$store.service.summary_total_hours,
					summary_total_hours_ot: vm.$store.service.summary_total_hours_ot
				}

				vm.postData("Service/save",payload)
			})
		},
		setWorksheet() {
			let vm = this

			if ("ServiceWorksheet" in this.$store.service && this.$store.service.ServiceWorksheet.length > 0) {
				this.worksheets = this.cloneObj(this.$store.service.ServiceWorksheet)
			}
			else {
				//auto-add our first worksheet, either as a blank one, or pull it from the service record if that exists (for back compatability)

				if ("work_completed_description" in this.$store.service && this.$store.service.work_completed_description) {

					this.worksheets = [
						{
							service_id: this.$store.service.id,
							work_completed_description: this.$store.service.work_completed_description,
							parts_used_json: this.$store.service.parts_used_json,
							equipment_used_json: this.$store.service.equipment_used_json,
							tasks_completed_json: this.$store.service.tasks_completed_json
						}
					]
				}
				else {
					this.worksheets = [
						{
							service_id: this.$store.service.id,
							work_completed_description: "",
							parts_used_json: "",
							equipment_used_json: "",
							tasks_completed_json: ""
						}
					]
				}
			}

			if (!vm.serviceStatusChecked) {
				vm.serviceStatusChecked = true

				//check if user is clocked into this service, and if status is completed toggle it back to incomplete
				if (vm.$store.clockedInJob.type == "Service" && vm.$store.clockedInJob.id == vm.$store.service.id && vm.$store.service.status == "Completed") {
					//user is clocked into this job
					vm.$store.service.status = "Incomplete: Other"
				}
			}

			let statusReset = vm.$store.service.status
			vm.$store.service.status = ""

			vm.$nextTick(() => {
				vm.$store.service.status = statusReset
			})

			setTimeout(() => {
				this.fieldsPopulatingInitially = false
			},2000)
		},
		setService() {
			let vm = this

			let promises = [
				this.fetchJobCategories(),
				this.fetchCustomers(),
				this.fetchServiceStatuses()
			]

			this.spinner(true)

			if (!("id" in this.$store.service) || this.$store.service.slug != this.$route.params.id)  {
				promises.push(this.fetchService())
			}
			else
				vm.setWorksheet()

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (promises.length == 4) {
					vm.$set(vm.$store,"service",responses[3].data)

					//if (vm.$store.service.contact_location_id > 0)
					//	vm.fetchContactLocation()

					vm.setWorksheet()
				}
				else {
					//if (vm.$store.service.contact_location_id > 0)
					//	vm.fetchContactLocation()
				}
					
			})
		},
		saveWorksheet(redirectToClockout) {
			let vm = this

			let payload = {
				id: this.$store.service.id,
				status: this.$store.service.status,
				signature_json: this.$store.service.signature_json,
				save_mode: "worksheet"
			}

			if (payload.status == "Completed")
				payload.completed = this.$store.service.completed
			else if (payload.status != "Completed")
				payload.completed = null

			this.formWorking = true

			this.postData("Service/save",payload,true).then(response => {
				vm.formWorking = false

				if (response.success) {

					vm.alertSaved("Worksheet saved!")

					//if status hasn't been changed yet, prompt to ask if status should be changed to complete
					if (redirectToClockout && vm.$store.service.status == 'Completed')
						vm.$router.push("/punch-clock")
					else if (redirectToClockout)
						vm.statusChangePromptModal.visible = true
				}
			
			})
		},
		fetchChecklists() {
			const vm = this

			this.getJSON("Checklist/get").then(response => {
				if (response.success)
					vm.checklists = response.data
			})
		},
		fetchFormChildTemplates() {
			const vm = this

			this.getJSON("FormChildTemplate/get").then(response => {
				if (response.success)
					vm.formChildTemplates = response.data
			})
		},
		fetchServiceData() {
			const vm = this

			if (this.fetchingServiceData || !(this.$store.service && 'id' in this.$store.service && this.$store.service.id))
				return

			this.fetchingServiceData = true    // enforce singleton design pattern

			let params = {
				fields: ['FormChildTemplate', 'CompanyForm','CustomerAsset','JobChecklist'],
				include: [
					{
						model: 'FormChildTemplate',
						fields: ['id', 'description']
					},
					{
						model: 'CompanyForm',
						fields: ['id', 'child_template_id', 'CompanyFormAcknowledgement'],
						include: [
							{ model: 'CompanyFormAcknowledgement', fields: ['name'] }
						]
					},
					{
						model: 'CustomerAsset',
						fields: ['id', 'slug', 'description']
					},
					{
						model: "JobChecklist",
						include: [
							{
								model: "CustomerAsset",
								fields: ["id", "slug", "description"]
							},
							"Category"
						]
					}
				]
			}

			this.getJSON('Service/find/' + this.$store.service.id, params).then(response => {

				if (response.success) {
					if ('CompanyForm' in response.data && response.data.CompanyForm)
						vm.$set(vm.$store.service, 'CompanyForm', response.data.CompanyForm)

					if ('FormChildTemplate' in response.data && response.data.FormChildTemplate)
						vm.$set(vm.$store.service, 'FormChildTemplate', response.data.FormChildTemplate)

					if ('CustomerAsset' in response.data && response.data.CustomerAsset)
						vm.$set(vm.$store.service, 'CustomerAsset', response.data.CustomerAsset)

					if ('JobChecklist' in response.data && response.data.JobChecklist)
						vm.$set(vm.$store.service, 'JobChecklist', response.data.JobChecklist)
				}

				vm.fetchingServiceData = false
			})

		},
		fetchTimeLogs() {
			let vm = this

			if (this.$store.service.id) {
				let params = {
					filters: [
						["service_id",this.$store.service.id]
					]
				}

				this.getJSON("TimeLog/get",params).then(response => {
					vm.timeLogs = response.data
				})
			}
		},
		fetchWorksheets() {
			let vm = this

			let params = {
				filters: [
					["service_id",this.$store.service.id]
				]
			}

			this.spinner(true)

			this.getJSON("ServiceWorksheet/get",params).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.worksheets = response.data

					vm.$store.service.ServiceWorksheet = response.data
				}
			})
		},
		fetchSuggestedMaterials() {
			let vm = this

			let quoteParams = {
				filters: [
					["is_quote",1],
					["service_id", vm.$store.service.id]
				],
				include: [
					{model: "ServiceInvoiceObject", filters: [["type","Material"]]}
				]
			}

			let poParams = {
				filters: [
					["service_id",vm.$store.service.id],
				]
			}

			let promises = [
				this.getJSON("ServiceInvoice/get",quoteParams),
				this.getJSON("PurchaseOrder/get",poParams)
			]

			Promise.all(promises).then(responses => {
				
				let materialsSet = new Set()

				//get materials on quote
				if  (responses[0].data.length > 0) {
					let quote = responses[0].data[0]

					if ("ServiceInvoiceObject" in quote && quote.ServiceInvoiceObject) {
						quote.ServiceInvoiceObject.forEach(obj => {
							
							try {
								let fieldValues = JSON.parse(obj.field_values_json)

								if ("material_id" in fieldValues && fieldValues.material_id > 1) //this is a material in the db
									materialsSet.add(fieldValues.material_id)
								else //this is a manual material
									materialsSet.add(fieldValues)
							}
							catch (e) {}
						})
					}
				}

				//compile materials from POs
				responses[1].data.forEach(po => {
					try {
						let lineItems = JSON.parse(po.line_items_json)

						lineItems.forEach(lineItem => {
							if ("material_id" in lineItem && lineItem.material_id)
								materialsSet.add(lineItem.material_id)
						})

						
					}
					catch (e) {}
				})

				this.suggestedMaterials = [...materialsSet] //convert to array
			})
		}
	},
	created(){
		let vm = this

		if (!("id" in this.$store.service) || this.$store.service.slug != this.$route.params.id) {
			this.setService()
			this.fetchServiceStatuses()
		}
		else {
			this.setServiceIfNotSet(["Customer","ServiceContract","ServiceWorksheet","JobChecklist"])

			this.fetchServiceStatuses().then(response => {
				vm.setWorksheet()
			})
		}

		this.fetchTimeLogs()
		this.fetchChecklists()
		this.fetchFormChildTemplates()
		//this.fetchServiceForms()

		this.$bus.$on("companyFormParticipantsSaved",(event) => {
			//vm.fetchServiceForms()
		})

		this.fetchServiceData()

	}
}
</script>

<style type="text/css" scoped>
	@media (max-width: 550px) {
		.action-buttons-container {
			margin-right: -15px;
			margin-left: -15px;
		}
	}
</style>